module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0031.jpg?v=a9539c35";